import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ContentSectionComponent } from '../../../../shared/components/custom';

@Component({
    selector: 'tran-customer-home-tile-section',
    imports: [ContentSectionComponent, TranslatePipe],
    templateUrl: './tile-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TileSectionComponent {
    protected readonly HOME_TILES = [
        {
            icon: 'element-radio-checked',
            title: 'home.building-organization.tiles.tile1.title',
            description: 'home.building-organization.tiles.tile1.description'
        },
        {
            icon: 'element-self-learning',
            title: 'home.building-organization.tiles.tile2.title',
            description: 'home.building-organization.tiles.tile2.description'
        },
        {
            icon: 'element-user-group',
            title: 'home.building-organization.tiles.tile3.title',
            description: 'home.building-organization.tiles.tile3.description'
        },
        {
            icon: 'element-timer',
            title: 'home.building-organization.tiles.tile4.title',
            description: 'home.building-organization.tiles.tile4.description'
        }
    ];
}
